import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const LANE_CLOSURE_SAFETY_POINT_LAYER_ID = 'laneClosureSafetyPointLayer';

const layerConfig = {
  title: 'Lane Closure Safety Point Layer',
};

// Keep color order aligned to the UI palette screenshot, ignoring its labels.
const TYPE_OF_WORK_COLORS = {
  'Electrical Work': [103, 188, 199],
  'Highway Construction': [232, 195, 102],
  'Pavement Work': [234, 141, 99],
  'Guardrail Work': [199, 160, 224],
  'Utility Work': [124, 188, 87],
};

const OTHER_WORK_COLOR = [163, 163, 163];

const getTypeOfWorkColor = (feature) => {
  const typeOfWork = feature?.properties?.Type_Of_Work;
  return TYPE_OF_WORK_COLORS[typeOfWork] || OTHER_WORK_COLOR;
};

function LaneClosureSafetyPointLayer() {
  const dispatch = useDispatch();
  const { laneClosureSafetyPointLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, laneClosureSafetyPointLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  let pointRadius = 4;
  if (viewState.zoom >= 12) {
    pointRadius = 8;
  } else if (viewState.zoom >= 10) {
    pointRadius = 7;
  } else if (viewState.zoom >= 8) {
    pointRadius = 6;
  }

  if (laneClosureSafetyPointLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: LANE_CLOSURE_SAFETY_POINT_LAYER_ID,
      geoColumn: 'geom',
      pointType: 'circle',
      stroked: false,
      filled: true,
      pointRadiusUnits: 'pixels',
      pointRadiusMinPixels: 4,
      pointRadiusMaxPixels: 10,
      getPointRadius: pointRadius,
      pickable: true,
      visible: laneClosureSafetyPointLayer.visible,
      opacity: laneClosureSafetyPointLayer.opacity,

      getFillColor: getTypeOfWorkColor,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: LANE_CLOSURE_SAFETY_POINT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
    });
  }
}

export default LaneClosureSafetyPointLayer;
